import * as React from 'react';

import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileIcon, { defaultStyles } from 'react-file-icon';
import { TFunction } from 'i18next';

interface Iprops {
    // '' rather than undefined: EditDocumentLibraryForm seeds and clears its
    // file state with an empty string.
    file: File | '';
    onRemove: () => void;
    t: TFunction;
}

export const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) {
        return `${bytes} B`;
    }
    const units = ['KB', 'MB', 'GB'];
    let size = bytes / 1024;
    let unitIndex = 0;
    while (Number(size.toFixed(1)) >= 1024 && unitIndex < units.length - 1) {
        size = size / 1024;
        unitIndex += 1;
    }
    return `${size.toFixed(1)} ${units[unitIndex]}`;
};

export const getFileExtension = (name: string): string => {
    const lastDot = name.lastIndexOf('.');
    return lastDot > 0 ? name.slice(lastDot + 1).toLowerCase() : '';
};

/*
 * The attached file, shown beneath FormUtil.FileInput's upload button.
 *
 * It lives outside the form on purpose. The filename cannot be passed to the
 * file control as meta.fileName, because that means adding the selected file to
 * the fieldConfig memo's dependencies, and a new fieldConfig makes
 * FormGenerator null its form and reseed every control from formState - the
 * rebuild that MMG-4342 documented as a silent-misfiling route.
 */
const AttachedFile: React.FC<Iprops> = ({ file, onRemove, t }) => {
    if (!file) {
        return null;
    }

    const extension = getFileExtension(file.name);

    return (
        <div className="attached-file">
            <FileIcon
                extension={extension}
                {...defaultStyles[extension]}
                size={24}
            />
            <span className="attached-file-name" title={file.name}>
                {file.name}
            </span>
            <span className="attached-file-size">
                {formatFileSize(file.size)}
            </span>
            <Button
                bsStyle="link"
                type="button"
                className="attached-file-remove"
                onClick={onRemove}
                title={t('manageDocument:removeFile')}
                aria-label={t('manageDocument:removeFile')}
            >
                <FontAwesomeIcon icon={['far', 'times']} />
            </Button>
        </div>
    );
};

export default AttachedFile;
